export default __webpack_public_path__ + "static/1_19-f70ec4a001f06bf788cf1f79f304500b.png";